export default __webpack_public_path__ + "assets/img/process_loader-1.521acbc8.gif";